export default {"src":"/_next/static/media/arrow.99344037.svg","height":17,"width":11};